var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5C10.4477 4.99998 10 5.44768 10 5.99997C9.99998 6.55225 10.4477 6.99998 11 7L15.5855 7.00016L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.2929 18.7071C5.68342 19.0976 6.31659 19.0976 6.70711 18.7071L17.0001 8.41403L17 13C17 13.5523 17.4477 14 18 14C18.5523 14 19 13.5523 19 13L19.0001 6.00026C19.0001 5.81142 18.9478 5.63481 18.8568 5.48413C18.8314 5.44202 18.803 5.40193 18.7718 5.36417C18.7513 5.33938 18.7297 5.31559 18.707 5.29289C18.7048 5.29076 18.7027 5.28864 18.7006 5.28652C18.5005 5.08998 18.2383 4.99455 17.9779 5.00024L11 5Z",
    fill: "#0B2373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.7c380684d2fc1e97c3049ed785041b2a.svg";
export { ForwardRef as ReactComponent };